import { ImageUploadWithPreview, InputSelect, TextField } from "components";
import { useCommon, usePermission } from "hooks";
import { Eye, EyeOff } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { userStatus } from "utils";
interface IUserItemEdit {
    onClose: () => void;
    onConfirm?: (a: any) => void;
}
export default function UserForm({ onClose, onConfirm }: IUserItemEdit) {
    const { isAdmin } = usePermission()
    const actionsUserState = useCommon(state => state.actionsUserState);
    const {
        register,
        control,
        handleSubmit,
        setValue,
    } = useForm({ defaultValues: { root: actionsUserState?.item ?? null } });
    const [showPassword, setShowPassword] = useState({
        passwd: false,
        cfpasswd: false,
    })

    useEffect(() => {
        if (actionsUserState?.item?.avatar) {
            setValue('root.avatar', null);
        }
        if (actionsUserState?.item?.status) {
            setValue('root.status', actionsUserState?.item?.status);
        }
    }, [actionsUserState?.item]);

    return (
        <div className="mx-auto bg-white rounded-lg ">
            <div className="content-modal p-4">
                <div className="grid md:grid-cols-2 gap-3 grid-cols-1">
                    <div>
                        <label className="block font-medium mb-1">Họ tên:</label>
                        <TextField
                            type="text"
                            placeholder="Nhập họ tên"
                            {...register("root.name")}
                        />
                    </div>
                    <div>
                        <label className="block font-medium mb-1">Email:</label>
                        <TextField
                            type="email"
                            {...register("root.email")}
                            placeholder="you@example.com"
                            required
                        />
                    </div>
                    <div className="relative">
                        <label className="block font-medium mb-1">Mật khẩu:</label>
                        <TextField
                            type={showPassword.passwd ? 'text' : 'password'}
                            {...register("root.password")}
                            placeholder="Nhập mật khẩu"
                            className="relative"
                        />
                        <button
                            type="button"
                            onClick={() => setShowPassword(s => ({ ...s, passwd: !showPassword.passwd }))}
                            className="absolute right-3 top-2/3 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        >
                            {showPassword.passwd ? <EyeOff size={20} /> : <Eye size={20} />}
                        </button>
                    </div>
                    <div className="shadow-none w-50">
                        <label className="block font-medium mb-1">Trạng thái</label>
                        <Controller
                            control={control}
                            name="root.status"
                            render={({ field }) => (
                                <InputSelect options={userStatus} {...field} />
                            )}
                        />
                    </div>

                    {isAdmin && <div className="shadow-none w-4 pl-8 py-2">
                        <div className="shadow-none w-4 flex justify-center items-center">
                            <label className="block font-medium mb-1 mr-3">Admin:</label>
                            <Controller
                                control={control}
                                name="root.isAdmin"
                                render={({ field }) => (
                                    <TextField
                                        type="checkbox"
                                        checked={field.value}
                                        onChange={(e) => field.onChange(e.target.checked)}
                                    />
                                )}
                            />
                        </div>
                    </div>}

                </div>
                <div>
                    <label className="block font-medium mb-1">Avatar:</label>
                    <p className="text-xs text-gray-400 mb-2">
                        Recommended thumbnail size 200×200 (px).
                    </p>
                    <Controller
                        control={control}
                        name="root.avatar"
                        render={({ field }) => (
                            <ImageUploadWithPreview {...field} onPick={f => field.onChange(f)} />
                        )}
                    />

                </div>
            </div>
            <div className="flex justify-center gap-2 p-4">
                <button
                    onClick={onClose}
                    className="bg-gray-500 text-white px-4 py-1 rounded hover:bg-gray-600"
                >
                    Huỷ
                </button>
                {!!onConfirm && <button
                    onClick={() => handleSubmit(onConfirm)()}
                    className="bg-green-500 text-white px-4 py-1 rounded hover:bg-green-600"
                >
                    Xác nhận
                </button>}
            </div>
        </div>
    );
}
